import {z} from 'zod';

export const Date = z.string().datetime({offset: true}).pipe(z.coerce.date());
export type Date = z.infer<typeof Date>;
